import * as React from "react"
import classNames from "classnames"
import "./Text.scss"

type TitleVariant = "sm" | "md" | "lg" | "xl" | "xxl"

type TextVariant = "xs" | "sm" | "md" | "lg" | "xl"

export type TWeight = 300 | 400 | 700 | 900

interface ITextProps {
  /** Tag name do text  */
  as?: keyof React.ReactHTML
  /** Tamanhos do texto */
  size?: TextVariant | TitleVariant
  /** Texto que quer exibir */
  children?: JSX.Element | string
  /** Classe adicional pro elemento */
  className?: string
  /** Peso da font */
  weight?: TWeight
}

const Text = ({
  size = "xl",
  children,
  className,
  weight,
  ...props
}: ITextProps) => {
  const CustomTagName = props.as || "p"
  const isTitle = CustomTagName.includes("h")
  const variant = isTitle ? "title" : "paragraph"

  delete props.as

  const rootClasses = classNames(
    "ds-text",
    `ds-text__${variant}`,
    `ds-text__${variant}--${size.toLowerCase()}`,
    {
      [className]: !!className,
    },
  )

  return (
    <CustomTagName
      className={rootClasses}
      {...props}
      style={{ ...props?.style, fontWeight: weight }}
    >
      {children}
    </CustomTagName>
  )
}

export default Text
